import type { ReactNode } from "react";
import { CircleAlert } from "lucide-react";
import { cn } from "@/shared/utils/cn";

export function PaymentNotice({ title, children, tone = "pending" }: {
  title: string; children: ReactNode; tone?: "pending" | "danger";
}) {
  return <div role={tone === "danger" ? "alert" : "status"} className={cn(
    "flex items-start gap-3 rounded-2xl border p-3 text-sm",
    tone === "danger" ? "border-danger/25 bg-danger-surface" : "border-warning/25 bg-warning-foreground/50",
  )}>
    <CircleAlert aria-hidden="true" className={cn("mt-0.5 size-5 shrink-0", tone === "danger" ? "text-danger" : "text-warning")} />
    <div className="min-w-0 space-y-1">
      <p className="font-semibold">{title}</p>
      <div className="leading-relaxed">{children}</div>
    </div>
  </div>;
}
